import styles from '@components/layout/admin/styles.module.css'
import { ChildrenProps } from '@interfaces/components/children'

const Layout = ({ children }: ChildrenProps) => {
  return (
    <div className={styles.wrapper}>
      {children}
    </div>
  )
}

export default Layout
